import React, { useState } from 'react';
import Button from '../../../components/Button';
import Heading from '../../../components/Heading';
import cx from 'classnames';
import styles from './DeleteFormModal.module.scss';

interface DeleteFormModalProps {
    formId: string;
    formName: string;
    onConfirm: (formId: string) => void;
    onCancel: () => void;
}

const Index: React.FC<DeleteFormModalProps> = ({
    formId, 
    formName, 
    onConfirm, 
    onCancel 
}) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleConfirm = async () => {
        setIsDeleting(true);
        try {
            onConfirm(formId);
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div>
            <div>
                <Heading level={3} classes="modal-heading">
                    Formular löschen
                </Heading>
            </div>

            <div>
                <p className={cx(styles['warning-text'])}>
                    Möchten Sie das Formular <strong>"{formName}"</strong> wirklich löschen?
                </p>
                <p className={cx(styles['info-text'])}>
                    Diese Aktion kann nicht rückgängig gemacht werden.
                </p>
            </div>

            <div className={cx(styles['button-container'])}>
                <Button
                    type="button"
                    hierarchy="secondary"
                    fn={onCancel}
                    disabled={isDeleting}
                    text="Abbrechen"
                />
                <Button
                    type="button"
                    hierarchy="primary"
                    fn={handleConfirm}
                    disabled={isDeleting}
                    text={isDeleting ? 'Lösche...' : 'Löschen'}
                />
            </div>
        </div>
    );
};

export default Index;